import conversions from '@sstdev/lib_epc-conversions';

/**
 * @param {*} hNode
 * @returns{(value: string) => string}
 */
// eslint-disable-next-line no-unused-vars
const toHexFromAscii = hNode => value => conversions.ascii.toHex(value.toString());
export default toHexFromAscii;
